import React from 'react';
import { Trash2, Edit, Share, Flag, Copy } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';

interface PostOptionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  isOwnPost: boolean;
  onDelete: () => void;
  onEdit?: () => void;
  onShare?: () => void;
  onReport?: () => void;
  onCopyLink?: () => void;
}

export const PostOptionsModal: React.FC<PostOptionsModalProps> = ({
  isOpen,
  onClose,
  isOwnPost,
  onDelete,
  onEdit,
  onShare,
  onReport,
  onCopyLink
}) => {
  const handleAction = (action: () => void) => {
    action();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Post Options">
      <div className="space-y-2">
        {isOwnPost ? (
          <>
            <button
              onClick={() => handleAction(onDelete)}
              className="w-full flex items-center px-4 py-3 text-left text-red-600 hover:bg-red-50 rounded-md transition-colors"
            >
              <Trash2 className="h-5 w-5 mr-3" />
              Delete Post
            </button>
            {onEdit && (
              <button
                onClick={() => handleAction(onEdit)}
                className="w-full flex items-center px-4 py-3 text-left text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
              >
                <Edit className="h-5 w-5 mr-3" />
                Edit Post
              </button>
            )}
          </>
        ) : (
          <>
            {onReport && (
              <button
                onClick={() => handleAction(onReport)}
                className="w-full flex items-center px-4 py-3 text-left text-red-600 hover:bg-red-50 rounded-md transition-colors"
              >
                <Flag className="h-5 w-5 mr-3" />
                Report Post
              </button>
            )}
          </>
        )}
        
        {onShare && (
          <button
            onClick={() => handleAction(onShare)}
            className="w-full flex items-center px-4 py-3 text-left text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
          >
            <Share className="h-5 w-5 mr-3" />
            Share Post
          </button>
        )}
        
        {onCopyLink && (
          <button
            onClick={() => handleAction(onCopyLink)}
            className="w-full flex items-center px-4 py-3 text-left text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
          >
            <Copy className="h-5 w-5 mr-3" />
            Copy Link
          </button>
        )}
        
        <div className="pt-2 border-t border-gray-200">
          <Button
            variant="outline"
            onClick={onClose}
            fullWidth
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};